module.exports = __webpack_public_path__ + "img/4.3d26bfb8.png";